import { render, staticRenderFns } from "./ProductsTypeFilter.vue?vue&type=template&id=80f21aae&"
import script from "./ProductsTypeFilter.vue?vue&type=script&lang=js&"
export * from "./ProductsTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "3feddcbc"
  
)

export default component.exports